import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { de } from './de.js';
import { en } from './en.js';

export const SUPPORTED_LANGUAGES = ['de', 'en'] as const;
export type Language = (typeof SUPPORTED_LANGUAGES)[number];

export function detectLanguage(candidates: readonly string[]): Language {
  for (const candidate of candidates) {
    const base = candidate.toLowerCase().split('-')[0];
    if (base && (SUPPORTED_LANGUAGES as readonly string[]).includes(base)) {
      return base as Language;
    }
  }
  return 'de';
}

export function setupI18n(languages: readonly string[] = []): typeof i18n {
  void i18n.use(initReactI18next).init({
    resources: {
      de: { translation: de },
      en: { translation: en },
    },
    lng: detectLanguage(languages),
    fallbackLng: 'de',
    interpolation: { escapeValue: false },
  });
  return i18n;
}

export { de, en };
